"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ContextMenu_1 = __importStar(require("./ContextMenu/ContextMenu"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var inversify_react_1 = require("inversify-react");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var DiscountPanel_1 = __importDefault(require("./DiscountPanel"));
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var c = (0, BemBuilder_1.default)("quote-section-toolbar-options");
var PlanSectionOptionsMenu = (function (_super) {
    __extends(PlanSectionOptionsMenu, _super);
    function PlanSectionOptionsMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlanSectionOptionsMenu.prototype.render = function () {
        var _this = this;
        var section = this.props.section;
        return (react_1.default.createElement(ContextMenu_1.default, { panelTheme: ContextMenu_1.ContextMenuPanelTheme.Dark, panelSize: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Edit, null), tooltip: { content: "Section options" } }, buttonProps))); }, items: [
                {
                    label: "Discount",
                    panelContents: (react_1.default.createElement(DiscountPanel_1.default, { discountStore: section.discount, telemetryHierarchy: QuoteTelemetry_1.QuoteTelemetryHierarchy.Section })),
                },
                {
                    label: "Properties",
                    panelContents: (react_1.default.createElement("div", { className: c("subpanel") },
                        [Types_1.QuoteSelectionType.Multi, Types_1.QuoteSelectionType.Single].includes(this.quote.quoteSelectionType) && (react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Optional section", value: !section.mandatory, onChange: function (next) {
                                section.mandatory = !next;
                                _this.quoteTelemetry.trackSectionOptionalChanged(next);
                            } })),
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Single select", value: section.itemSingleSelect, onChange: function (next) {
                                section.itemSingleSelect = next;
                                _this.quoteTelemetry.trackItemSingleSelectChanged(next, Types_1.QuoteSectionDisplayMode.PlanCards);
                            } }),
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show features", value: section.showFeatureList, onChange: function (next) {
                                section.showFeatureList = next;
                                _this.quoteTelemetry.trackPlanCardSectionShowFeaturesChanged(next);
                            } }),
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Group plans by billing frequency", value: section.groupByBillingSchedule, onChange: function (next) {
                                section.groupByBillingSchedule = next;
                                _this.quoteTelemetry.trackPricingPlanSectionGrouping(next);
                            } }))),
                },
            ] }));
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _a : Object)
    ], PlanSectionOptionsMenu.prototype, "quoteTelemetry", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _b : Object)
    ], PlanSectionOptionsMenu.prototype, "quote", void 0);
    PlanSectionOptionsMenu = __decorate([
        mobx_react_1.observer
    ], PlanSectionOptionsMenu);
    return PlanSectionOptionsMenu;
}(react_1.default.Component));
exports.default = PlanSectionOptionsMenu;
